import { render, staticRenderFns } from "./morePlatforms.vue?vue&type=template&id=512aec3c&scoped=true"
import script from "./morePlatforms.vue?vue&type=script&lang=js"
export * from "./morePlatforms.vue?vue&type=script&lang=js"
import style0 from "./morePlatforms.vue?vue&type=style&index=0&id=512aec3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512aec3c",
  null
  
)

export default component.exports